/******************************************************************************************
 *	Alert Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.alertModal', [])
    .constant('ALERT_MODAL_TYPES', {
      ERROR: 'error',
      NOTICE: 'notice',
      SUCCESS: 'success',
      HELP: 'help',
      INFO: 'info'
    })
    .factory(
      'AlertModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/alert-modal.html',
          controller: 'AlertModalController',
          classNames: 'alert-modal'
        });
      }
    )
    .controller(
      'AlertModalController',
      /* @ngInject */
      function($scope, AlertModal) {
        //Set modal type
        if ($scope.type) {
          AlertModal.setType($scope.type);
        }
        if ($scope.additionalStyling) {
          AlertModal.setType($scope.additionalStyling);
        }

        //Close modal
        $scope.removeModal = function() {
          //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
          AlertModal.remove({cancelled: true});
        };
      }
    );
})();
